var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7387 16.4137C21.5716 17.6841 20.9477 18.8501 19.9837 19.6941C19.0196 20.5381 17.7813 21.0023 16.5 21C9.05624 21 2.99999 14.9438 2.99999 7.5C2.9977 6.21871 3.46189 4.9804 4.30587 4.01634C5.14985 3.05228 6.3159 2.42841 7.58624 2.26125C7.90748 2.22203 8.23279 2.28775 8.51361 2.4486C8.79442 2.60945 9.01569 2.85681 9.14437 3.15375L11.1244 7.57406V7.58531C11.2229 7.81261 11.2636 8.06077 11.2428 8.30763C11.222 8.55449 11.1404 8.79236 11.0053 9C10.9884 9.02531 10.9706 9.04875 10.9519 9.07219L8.99999 11.3859C9.70218 12.8128 11.1947 14.2922 12.6403 14.9963L14.9222 13.0547C14.9446 13.0359 14.9681 13.0183 14.9925 13.0022C15.2 12.8638 15.4386 12.7793 15.687 12.7564C15.9353 12.7335 16.1854 12.7729 16.4147 12.8709L16.4269 12.8766L20.8434 14.8556C21.1409 14.9838 21.3889 15.2049 21.5502 15.4858C21.7116 15.7666 21.7778 16.0922 21.7387 16.4137Z",
    fill: "#ffffff60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.908a0ac10fb1ff762d37fc135ea9dce1.svg";
export { ForwardRef as ReactComponent };